export default __webpack_public_path__ + "static/media/investment.8cdd711c.jpg";